<template>
  <v-dialog
    :model-value="dialog.show"
    max-width="520"
    persistent
    @update:model-value="(value) => !value && $emit('close')"
  >
    <v-card>
      <v-card-title>{{ $t("settings.profile.emailAccounts.dialog.delete.title") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <p class="mb-3">
          {{
            $t("settings.profile.emailAccounts.dialog.delete.confirmText", {
              name: dialog.account?.name || "",
            })
          }}
        </p>
        <p class="text-caption text-medium-emphasis mb-3">
          {{ $t("settings.profile.emailAccounts.dialog.delete.confirmHint") }}
        </p>
        <v-text-field
          :model-value="dialog.confirmation"
          @update:model-value="$emit('update:confirmation', $event)"
          :label="$t('settings.profile.emailAccounts.dialog.delete.confirmType')"
          autocomplete="off"
        />
        <v-alert v-if="dialog.error" type="error" class="mt-2">
          {{ dialog.error }}
        </v-alert>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="dialog.deleting" @click="$emit('close')">
          {{ $t("settings.profile.emailAccounts.dialog.actions.cancel") }}
        </v-btn>
        <v-btn
          color="error"
          :loading="dialog.deleting"
          :disabled="dialog.confirmation !== 'DELETE'"
          @click="$emit('confirm')"
        >
          {{ $t("settings.profile.emailAccounts.dialog.actions.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UserEmailAccountDeleteDialog",
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "confirm", "update:confirmation"],
};
</script>
